module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=PR - Puerto Rico.b0a19f5a.svg";